import { create } from "zustand";

interface TrainingState {
  isTraining: boolean;
  setIsTraining: (v: boolean) => void;
}

export const useTrainingStore = create<TrainingState>((set) => ({
  isTraining: false,
  setIsTraining: (isTraining) => set({ isTraining }),
}));
